import collaborator1 from '../assets/collaborators/Hacienda_de_San_Antonio.png';
import collaborator2 from '../assets/collaborators/Museo_Menonita.png';
import collaborator3 from '../assets/collaborators/Bravo_Cafe_Bar.png';
import collaborator4 from '../assets/collaborators/Simons_Kaffee.png';
import collaborator5 from '../assets/collaborators/Iberoamerica_Ilustra.png';
import collaborator6 from '../assets/collaborators/La_Habanera.png';
import collaborator7 from '../assets/collaborators/Sr_Cantaloup.png';
import collaborator8 from '../assets/collaborators/Estudio_Lapis.png';
import collaborator9 from '../assets/collaborators/Microtel_In_Suites_by_Wyndham.png';
import collaborator10 from '../assets/collaborators/Festival_de_Cine_de_Tecoman.png';
import collaborator11 from '../assets/collaborators/Veleta_Roja.png';
import collaborator12 from '../assets/collaborators/Editorial_Alcaraña.svg';
import collaborator13 from '../assets/collaborators/Santillana.svg';
import collaborator14 from '../assets/collaborators/CaboDevelopment.svg';
import collaborator15 from '../assets/collaborators/casa_careyes.png';
import collaborator16 from '../assets/collaborators/punto_de_partida.png';
import collaborator17 from '../assets/collaborators/Higareda_Interiores.png';
import collaborator18 from '../assets/collaborators/Filling_Station_Magazine.png';
import collaborator19 from '../assets/collaborators/They_Draw_and_Travel.png';

export const collaboratorLogo = {
    Hacienda_de_San_Antonio : collaborator1,
    Museo_Menonita : collaborator2,
    Bravo_Cafe_Bar : collaborator3,
    Simons_Kaffee : collaborator4,
    Iberoamerica_Ilustra : collaborator5,
    La_Habanera : collaborator6,
    Sr_Cantaloup : collaborator7,
    Estudio_Lapis : collaborator8,
    Microtel_In_Suites_by_Wyndham : collaborator9,
    Festival_de_Cine_de_Tecoman : collaborator10,
    Veleta_Roja : collaborator11,
    Editorial_Alacraña : collaborator12,
    Santillana : collaborator13,
    CaboDevelopment : collaborator14,
    Casa_Careyes : collaborator15,
    Punto_de_Partida_UNAM : collaborator16,
    Higareda_Interiores : collaborator17,
    Filling_Station_Magazine : collaborator18,
    They_Draw_and_Travel : collaborator19,
}
